import React from 'react'
import Main from '../../components/main/Main';
import DemandListReports from './Helpers/DemandListReports';

function IsYogunlugu() {

  return (
    <Main>
        <DemandListReports />
    </Main>
  )
}

export default IsYogunlugu